// @flow

// Libs
import { createSelector } from 'reselect'

// Selectors
import { activeRoute$ } from 'hfty-navigation-web'
import { jobs$ } from 'hfty-soil-jobs'

// Constants
import { REPORTS_LAB_RESULTS_ROUTE } from 'hfty-soil-jobs-dom'
import { PROP_ID, PROP_FIELD } from 'hfty-model-soil-jobs'

// Types
import { SoilJob } from 'hfty-model-soil-jobs/types'

export default createSelector(
  [activeRoute$, jobs$],
  (activeRoute: string, jobs: Array<SoilJob> = []): number => {
    const jobId = +activeRoute.replace(`${REPORTS_LAB_RESULTS_ROUTE}/`, '')
    const job = jobs.find((job: SoilJob): boolean => job[PROP_ID] === jobId) || {}

    return job[PROP_FIELD]
  }
)
